import Grid from '@mui/material/Grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import WbSwitch from '../../../components/common/WbSwitch'
import {useEffect} from 'react'
import {Autocomplete, Chip, IconButton, TextField} from '@mui/material'
import {Add, RemoveCircleOutline} from '@mui/icons-material'
import {displayOperatorLabel} from '../../../utils/operatorLabels'

export default function ParticipantFilters({
  participantFilter,
  setParticipantFilter,
  audience,
  availableFilter,
  updateInDb,
}) {
  useEffect(() => {
    if (
      participantFilter.filterValues?.filter(x => x.audience === audience)
        .length === 0
    ) {
      setParticipantFilter({
        ...participantFilter,
        filterValues: [
          {
            audience,
            table: null,
            name: null,
            join: 'and',
            operator: null,
            values: null,
          },
        ],
      })
    }
  }, [])

  const updateFilters = (index, filter) => {
    const f = participantFilter.filterValues.filter(
      x => x.audience === audience
    )
    f[index] = filter

    var newParticipantFilter = {
      ...participantFilter,
      filterValues: [
        ...participantFilter.filterValues.filter(x => x.audience !== audience),
        ...f,
      ],
    }
    setParticipantFilter({...newParticipantFilter})
    if (
      filter.name === null ||
      filter.operator === null ||
      filter.values === null
    ) {
      return
    }
    updateInDb(newParticipantFilter, audience)
  }
  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div className="participant-filter-box">
          <div className="participant-filter">
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControlLabel
                  control={
                    <WbSwitch
                      size="small"
                      checked={
                        audience === 'Student'
                          ? participantFilter?.allStudent
                          : participantFilter?.allStaff
                      }
                      onChange={e => {
                        var tt = {
                          ...participantFilter,
                          allStudent:
                            audience === 'Student'
                              ? e.target.checked
                              : participantFilter.allStudent,
                          allStaff:
                            audience === 'Student'
                              ? participantFilter.allStaff
                              : e.target.checked,
                        }
                        if (tt.filterValues == null) {
                          tt.filterValues = []
                        }
                        if (
                          tt.filterValues?.filter(x => x.audience === audience)
                            .length === 0 &&
                          !e.target.checked
                        ) {
                          tt.filterValues?.push({
                            audience,
                            table: null,
                            name: null,
                            join: null,
                            operator: null,
                            values: null,
                          })
                        }
                        setParticipantFilter({...tt})
                        updateInDb(tt, audience)
                      }}
                    ></WbSwitch>
                  }
                  label={`All ${audience}`}
                ></FormControlLabel>
              </Grid>
            </Grid>
            {((audience === 'Student' && !participantFilter?.allStudent) ||
              (audience === 'Staff' && !participantFilter?.allStaff)) &&
              participantFilter?.filterValues
                .filter(x => x.audience === audience)
                .map((filter, index) => {
                  const matchedFilter = availableFilter?.find(
                    x => x.name === filter.name
                  )
                  // Dedupe options by value so a single saved value
                  // (e.g. "%Accounting%") can only ever map to one chip.
                  // Without this, a duplicated source list makes
                  // selectList.filter(...) below return one chip per
                  // duplicate, showing the same value many times.
                  const rawSelectList = matchedFilter?.selectList ?? []
                  const selectList = rawSelectList.filter(
                    (o, i) =>
                      rawSelectList.findIndex(x => x.value === o.value) === i
                  )
                  let parsedValues = []
                  if (filter.values) {
                    try {
                      parsedValues = JSON.parse(filter.values)
                    } catch {
                      parsedValues = []
                    }
                  }
                  return (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="filter-block">
                        <div className="filter-row">
                          <div className="filter-cell filter-cell-join">
                            {index === 0 ? (
                              `where ${audience}`
                            ) : (
                              <Autocomplete
                                disableClearable
                                fullWidth
                                options={['and', 'or']}
                                value={filter.join ?? 'and'}
                                onChange={(e, val) =>
                                  updateFilters(index, {
                                    ...filter,
                                    join: val,
                                  })
                                }
                                renderInput={params => (
                                  <TextField {...params} size="small" />
                                )}
                              />
                            )}
                          </div>
                          <div className="filter-cell filter-cell-name">
                            <Autocomplete
                              fullWidth
                              options={availableFilter ?? []}
                              getOptionLabel={option => option.displayName ?? ''}
                              isOptionEqualToValue={(option, value) =>
                                option.name === value.name
                              }
                              value={
                                availableFilter?.find(
                                  x => x.name === filter.name
                                ) ?? null
                              }
                              onChange={(e, val) => {
                                updateFilters(index, {
                                  ...filter,
                                  name: val?.name ?? null,
                                  table: val?.table,
                                  values: null,
                                })
                              }}
                              renderInput={params => (
                                <TextField {...params} size="small" />
                              )}
                            />
                          </div>
                          <div className="filter-cell filter-cell-operator">
                            <Autocomplete
                              fullWidth
                              options={matchedFilter?.operators ?? []}
                              getOptionLabel={option =>
                                displayOperatorLabel(option.label)
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                              }
                              value={
                                matchedFilter?.operators?.find(
                                  o => o.value === filter.operator
                                ) ?? null
                              }
                              onChange={(e, val) => {
                                updateFilters(index, {
                                  ...filter,
                                  operator: val?.value ?? null,
                                })
                              }}
                              renderInput={params => (
                                <TextField {...params} size="small" />
                              )}
                            />
                          </div>
                          <div className="filter-cell filter-cell-values">
                            {matchedFilter?.controlType === 1 ? (
                              <Autocomplete
                                multiple
                                disableCloseOnSelect
                                fullWidth
                                options={selectList}
                                getOptionLabel={option =>
                                  String(option.label ?? '')
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value.value
                                }
                                value={selectList.filter(o =>
                                  parsedValues.includes(o.value)
                                )}
                                onChange={(e, vals) =>
                                  updateFilters(index, {
                                    ...filter,
                                    values: JSON.stringify(
                                      vals.map(v => v.value)
                                    ),
                                    table: matchedFilter?.table,
                                  })
                                }
                                renderTags={(value, getTagProps) =>
                                  value.map((option, i) => (
                                    <Chip
                                      label={option.label}
                                      {...getTagProps({index: i})}
                                    />
                                  ))
                                }
                                renderInput={params => (
                                  <TextField {...params} size="small" />
                                )}
                              />
                            ) : (
                              <TextField
                                fullWidth
                                size="small"
                                value={filter.values ?? ''}
                                type="number"
                                placeholder={matchedFilter?.placeholder}
                                onChange={e =>
                                  updateFilters(index, {
                                    ...filter,
                                    values: e.target.value,
                                    table: matchedFilter?.table,
                                  })
                                }
                              />
                            )}
                            <IconButton
                              onClick={e => {
                                var pf = {
                                  ...participantFilter,
                                  filterValues: [
                                    ...participantFilter.filterValues,
                                    {
                                      audience,
                                      table: null,
                                      name: null,
                                      join: null,
                                      operator: null,
                                      values: null,
                                    },
                                  ],
                                }
                                setParticipantFilter({...pf})
                              }}
                              disableRipple
                            >
                              <Add />
                            </IconButton>
                          </div>
                        </div>

                        <div>
                          <IconButton>
                            <RemoveCircleOutline
                              onClick={e => {
                                var fvals = [
                                  ...participantFilter.filterValues.filter(
                                    x => x.audience === audience
                                  ),
                                ]
                                var otherVals = [
                                  ...participantFilter.filterValues.filter(
                                    x => x.audience !== audience
                                  ),
                                ]
                                fvals.splice(index, 1)
                                var pf = {
                                  ...participantFilter,
                                  allStudent:
                                    audience === 'Student' && fvals.length === 0
                                      ? true
                                      : participantFilter.allStudent,
                                  allStaff:
                                    audience === 'Staff' && fvals.length === 0
                                      ? true
                                      : participantFilter.allStaff,
                                  filterValues: [...otherVals, ...fvals],
                                }
                                setParticipantFilter({...pf})
                                updateInDb(pf, audience)
                              }}
                            />
                          </IconButton>
                        </div>
                      </div>
                    </Grid>
                  )
                })}
          </div>
        </div>
      </Grid>
    </Grid>
  )
}
